import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Button from '@material-ui/core/Button';
import {DialogContentText, DialogActions} from '@material-ui/core';
import { translate } from 'react-i18next';
import Util from "../../../../util";
import {API} from "../../../../config";

const sell_order = API.service('sell-order');
const buy_order = API.service('buy-order');

const styles = theme => ({
  tableRow:{
    borderWidth:'1px 0 1px 0',
    borderColor:'#e6e6e6',
    '&:nth-of-type(2n)':{
      backgroundColor:'#f6f6f6'
    },
    '& td':{
      padding:7,
    },
    '&:first-of-type':{
      borderTop:0,
    },
  },
  tableHead:{
    borderWidth:'1px 0 1px 0',
    borderColor:'#e6e6e6',
    backgroundColor:'#6e6e6e',
    color:'white'
  },
  accountDetails:{
    width:'300px',
    position:'absolute',
    display:'none',
    //border:'2px solid ' + theme.navigation.selected.backgroundColor,
    backgroundColor:'white',
    top:0,
    right:50,
    zIndex:1000,
  },
  bankDetails:{
    '&:hover .details_drawer':{
      display:'block'
    }
  },
  debutton:{
    float:'right',
    marginBottom:'5px',
    marginRight:'5px'
  }
});

class CancelOrder extends Component {

  state = {}

  cancelOrder = (e, id, type) =>{
    e.preventDefault();
    if(type === 'buy'){
      buy_order.remove(id).then(()=>{
        this.setState({
          processing:false,
        }, function(){
          this.props.context.update({
            updateOrders:true
          })
          this.closeDialog()
        })
      })
    } else if (type === 'sell'){
      sell_order.remove(id).then(()=>{;
        this.setState({
          processing:false,
        }, function(){
          this.props.context.update({
            updateOrders:true
          })
          this.closeDialog()
        })
      })
    }
    //this.props.addTrade("add");

    return false;
  };

  closeDialog = () => {
    this.props.context.update({
      popupContent: false,
    })
  }

  render() {
    const {t} = this.props;
    let { currency_symbol } = (this.props.order.Companies.length !== 0) ? Util.getCurrency(this.props.order.Companies[0]._currency) : '';
    return (
      <React.Fragment>
        <DialogContentText id="alert-dialog-description">
          {t('user_panel_cancellation_canceling_in')} {(typeof this.props.order._target_seller_account === 'undefined') ? t('user_panel_history_order_sell') : t('user_panel_history_order_buy')} {t('user_panel_cancellation_order_for')} {Util.addThousandCommas(this.props.order._quantity, '0,0')} @ {this.state.symbol}
          {(this.props.order.Companies[0]._share_type !== 'D') &&
            <React.Fragment>
              {currency_symbol}{Util.addThousandCommas(this.props.order._price)} {this.state.currency}
            </React.Fragment>
          }
          {(this.props.order.Companies[0]._share_type === 'D') &&
            <React.Fragment>
              {this.props.order._price*100}%&nbsp;
            </React.Fragment>
          }
          {t('user_panel_cancellation_in')} {this.props.order.Companies[0]._company_symbol}.
          <br />
          <b>{t('user_panel_cancellation_continue')}</b>
        </DialogContentText>

          {(!this.state.processing) &&
          <DialogActions>
            <Button style={{color:'white',background:'red'}} onClick={this.closeDialog} color="primary">
              {t('user_panel_cancellation_cancel')}
            </Button>
            {(this.props.order._status === 0 && !(typeof this.props.order._target_seller_account === 'undefined')) &&
              <Button style={{color:'white',background:'green'}} onClick={ (e) => this.cancelOrder(e, this.props.order._id, 'buy')} color="primary" autoFocus>
                {t('user_panel_cancellation_continue_btn')}
              </Button>
            }
            {(this.props.order._status === 0 && (typeof this.props.order._target_seller_account === 'undefined')) &&
              <Button style={{color:'white',background:'green'}} onClick={ (e) => this.cancelOrder(e, this.props.order._id, 'sell')} color="primary" autoFocus>
                {t('user_panel_cancellation_continue_btn')}
              </Button>
            }
          </DialogActions>
          }
      </React.Fragment>
    )
  }
}
export default withContext(withStyles(styles,{withTheme:true})(withRouter(translate('translations') (CancelOrder))));
